import HiredCandidatesForm from "../../components/HiredCandidatesForm";

function HiredCandidatesFormPage() {
  return <HiredCandidatesForm />;
}

export default HiredCandidatesFormPage;
